// The application name to be displayed in the document title.
export const APP_NAME = process.env.REACT_APP_NAME || 'Resto App';

//  Whether the app is set up to run demo sessions.
export const IS_DEMO_MODE = process.env.REACT_APP_IS_DEMO_MODE === 'true';

// The path to the directory containing data for the internationalization of the app.
export const I18N_PATH = process.env.REACT_APP_I18N_PATH || './locales';

//real time db
export const WEBSOCKET_HOST = process.env.REACT_APP_WEBSOCKET_HOST || 'wss://mocken.me:8080';

//mocken pos
export const HOST_POS = process.env.REACT_APP_HOST_POS || 'https://mocken.me/crc'